import { RootProps } from '../root.js'
import { View } from '../view.js'

export const getRootProps = (view: View): RootProps => {
    const rawRoute = window.location.hash.substring(2) // Remove '#/' prefix

    const props: RootProps = {
        view,
    }

    return props
}
